import React, { FC, useState } from 'react';

import { Container } from '@mui/material';
import cn from 'classnames';

import { H2 } from '../../components/UI/Texts';
import styled from '../../styled';
import { colorsPalette, LARGE_MARGIN_PX, MIDDLE_MARGIN_PX, SUBMIDDLE_MARGIN_PX } from '../../theme';
import { Background, Faq } from '../../types';
import SingleAccordion from './SingleAccordion';

interface AccordionsBlockProps {
  data: Faq;
}

const AccordionsBlock: FC<AccordionsBlockProps> = ({ data }) => {
  const { background, heading, questions } = data;

  const [selectedIndex, setSelectedIndex] = useState<number>(0);

  const handleSelect = (index) => {
    setSelectedIndex((prevState) => (prevState !== index ? index : -1));
  };

  return (
    <Wrapper
      className={cn(
        background === Background.Dark ? 'dark-block' : 'light-block',
        'accordions-block',
      )}
      background={background}
    >
      <StyledContainer>
        <Title align="center" variant="h2">
          {heading}
        </Title>
        <AccordionsWrapper>
          {Boolean(questions?.length) &&
            questions?.map((item, i) => (
              <SingleAccordion
                id={i}
                title={item?.title}
                description={item?.description}
                isOpened={selectedIndex === i}
                handleOpen={handleSelect}
              />
            ))}
        </AccordionsWrapper>
      </StyledContainer>
    </Wrapper>
  );
};

export default AccordionsBlock;

const Wrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'background',
})`
  padding: ${MIDDLE_MARGIN_PX} 0;
  background: ${colorsPalette.blueDark};
  ${({ theme }) => theme.breakpoints.up('sm')} {
    background: ${({ background }) =>
      background === Background.Dark ? colorsPalette.blueDark : colorsPalette.blackSecondary};
    padding: ${LARGE_MARGIN_PX} 0;
  }
`;
const StyledContainer = styled(Container)`
  && {
    max-width: 1000px;
  }
`;
const Title = styled(H2)`
  && {
    margin-bottom: ${MIDDLE_MARGIN_PX};
    ${({ theme }) => theme.breakpoints.up('md')} {
      margin-bottom: ${SUBMIDDLE_MARGIN_PX};
    }
  }
`;
const AccordionsWrapper = styled('div')`
  width: 100%;
`;
